export default __webpack_public_path__ + "static/media/reliquaryofflame.b9cf7646.jpg";